import React from 'react';
// import { useNavigate } from 'react-router-dom';
import '../styles/layout.css';
import '../styles/recuperacao.css';

interface Props {
  title: string;
  description?: string;
}

const PlaceholderPage: React.FC<Props> = ({ title, description }) => {
  // const navigate = useNavigate();
  return (
    <div className="ccc-page-placeholder">
      <h2>{title}</h2>
      <p>{description || 'Esta área será disponibilizada numa fase seguinte.'}</p>
      {/* <button type="button" className="btn btn-primary" onClick={() => navigate('/recuperacao')}>
        Ir para Recuperação
      </button> */}
    </div>
  );
};

export default PlaceholderPage;
